import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { reduxForm } from 'redux-form'

import Footer from '../components/common/Footer'
import Header from '../components/common/Header'
import ModalPopup from '../components/common/ModalPopup'
import ReferralSuccessNotification from '../components/community/ReferralSuccessNotification'
import ModalUpdateUserLocation from '../components/location-search/ModalUpdateUserLocation'
import LoginOrJoin from '../components/login/LoginOrJoin'
import ConfirmRegisterForm from '../components/register/ConfirmRegister'
import SlackBotSuccessModal from '../components/slack/SlackBotSuccessModal'
import GenericSuccessModal from '../components/success-modal/GenericSuccessModal'
import { loadUserSavedLocationsStart } from '../redux/modules/location'
import { notificationAck } from '../redux/modules/notification'
import { loadProfileStart } from '../redux/modules/profile'
import {
  isSelectedDeliveryDateActive,
  selectCurrentLocationWithAddress,
  selectUserLocationId,
} from '../redux/modules/selectors'
import {
  currentUserStart,
  logoutStart,
  updateAndSaveUserLocationStart,
} from '../redux/modules/user'
import { noLocationRoute, registerRoute } from '../routes/routes'
import { LocationType } from '../util/constants'
import EmailVerificationBanner from '../components/email-verification/EmailVerificationBanner'
export const ConfirmRegisterContainer = reduxForm({ form: 'confirmpassword' })(ConfirmRegisterForm)

const getRedirect = location => {
  if (location) {
    if (location.locationType === LocationType.GROUP_ORDER) {
      const query = new URLSearchParams()
      const { city, state, street, zip } = location.address
      query.set('address', `${street} ${city}, ${state} ${zip}`)
      return <Redirect to={`${registerRoute.path}?${query.toString()}`} />
    } else if (location.activationDate === null) {
      return <Redirect to={noLocationRoute.path} />
    }
  }
  return null
}
export class LayoutPrivate extends Component {
  componentDidMount() {
    this.props.currentUserStart(true, true)
    this.props.loadProfileStart()
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.currentUser && this.props.currentUser) {
      this.props.loadProfileStart()
      this.props.loadUserSavedLocationsStart()
    }

    if (prevProps.location !== this.props.location && this.props.currentUser) {
      this.props.loadUserSavedLocationsStart()
    }
  }

  render() {
    const {
      children,
      confirmPasswordError,
      confirmPasswordStart,
      createSavedLocationError,
      currentUser,
      error,
      flex,
      hideHeader,
      history,
      isAuthenticated,
      isCurrentUserLoading,
      isLocationLoading,
      isSavedLocationsLoading,
      isSelectedDayActive,
      location,
      locationError,
      message,
      notificationAck,
      profile,
      savedLocationError,
      showSubNav,
      submitting,
      updateUserLocationError,
      userLocationId,
    } = this.props
    const newUser = profile && profile.status !== 'CONFIRMED'
    const redirect = getRedirect(location)

    /*
      Show the update user location dialog
      If the location is not user's profile location but is in user's saved locations list
          Or if there is an error in the modal
    */
    const errorInLocationUpdateModal = !!createSavedLocationError || !!updateUserLocationError
    const successSavedLocationsLoading = !isSavedLocationsLoading && !savedLocationError
    const successLocationLoading = !isLocationLoading && !locationError
    const showLocationUpdateModal =
      (successSavedLocationsLoading &&
        successLocationLoading &&
        userLocationId &&
        userLocationId !== location?.deliveryLocationId) ||
      errorInLocationUpdateModal

    return (
      <div
        style={
          flex
            ? {
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
              }
            : {}
        }
      >
        {redirect}
        {/* Asks if you want to change and save your location permanently when browsing */}
        {location && (
          <ModalUpdateUserLocation
            locationId={location.deliveryLocationId}
            open={showLocationUpdateModal}
          />
        )}
        {/* We don't want to show this modal for inactive/upcoming locations because there is already a sign up form in that page */}
        {/* TODO: We probably want the coming soon page in its own public layout */}
        {!isAuthenticated && isSelectedDayActive && (
          <ModalPopup showCancel={false}>
            <LoginOrJoin
              joinTitle="Register to Order"
              locationId={userLocationId}
              loginMessage="Log in to see available restaurants delivering to you."
              loginTitle="Log in to Order"
              signupMessage="Sign up to see available restaurants delivering to you."
            />
          </ModalPopup>
        )}
        {newUser && (
          <ModalPopup showCancel={false}>
            <ConfirmRegisterContainer
              confirmPasswordError={confirmPasswordError}
              onSubmit={confirmPasswordStart}
              submitting={submitting}
            />
          </ModalPopup>
        )}
        {!isCurrentUserLoading && !hideHeader && (
          <Header
            avatarId={profile && profile.avatarId}
            currentUser={currentUser}
            history={history}
            profileStatus={profile && profile.status}
            showSubNav={showSubNav}
          />
        )}
        <SlackBotSuccessModal />
        <ReferralSuccessNotification />
        {profile?.verifiedEmail === false && <EmailVerificationBanner profile={profile} />}
        <GenericSuccessModal isError={error} message={message} notificationAck={notificationAck} />
        {children}
        <Footer isAuthenticated={isAuthenticated} showLogo="true" />
      </div>
    )
  }
}

const mapStateToProps = state => {
  const location = selectCurrentLocationWithAddress(state)
  const userLocationId = selectUserLocationId(state)
  const isSelectedDayActive = isSelectedDeliveryDateActive(state)
  const { error, message } = state.notification
  const { profile } = state.profile
  const {
    confirmPasswordError,
    currentUser,
    isAuthenticated,
    isCurrentUserLoading,
    submitting,
    updateUserLocationError,
  } = state.user
  const {
    createSavedLocationError,
    isLocationLoading,
    isSavedLocationsLoading,
    locationError,
    savedLocationError,
  } = state.location

  return {
    confirmPasswordError,
    createSavedLocationError,
    currentUser,
    error,
    isAuthenticated,
    isCurrentUserLoading,
    isLocationLoading,
    isSavedLocationsLoading,
    isSelectedDayActive,
    location,
    locationError,
    message,
    profile,
    savedLocationError,
    submitting,
    updateUserLocationError,
    userLocationId,
  }
}

const mapDispatchToProps = {
  currentUserStart,
  loadProfileStart,
  loadUserSavedLocationsStart,
  logoutStart,
  notificationAck,
  updateAndSaveUserLocationStart,
}

export default connect(mapStateToProps, mapDispatchToProps)(LayoutPrivate)
